module.exports = __webpack_public_path__ + "static/media/welcome.c1af0ec2.png";